module.exports = __webpack_public_path__ + "img/aw.e6baac79.svg";